<template>
  <header class="app-header">
    <div class="app-header__side app-header__side--start">
      <portal-target name="app-header-start" />
    </div>

    <div class="app-header__brand">
      <portal-target name="app-header-brand" />
    </div>

    <!-- Mirrors the start slot so the brand stays optically centred in the row. -->
    <div class="app-header__side app-header__side--end" aria-hidden="true" />
  </header>
</template>

<script>
/**
 * The app's one header row (BOO-312).
 *
 * It is rendered once, globally, inside `grid-universal-header` — the same grid
 * row the top tab bar used to occupy. Being a real grid row (not `position:
 * fixed`) is the whole point: no screen can slide underneath the hamburger, so
 * the access-code screen stops rendering its heading under the button.
 *
 * Both slots are filled through portals rather than props so each screen keeps
 * ownership of its own conditions:
 *   - `app-header-start` — the hamburger toggle, portalled by UtilityMenu.vue,
 *     which stays mounted at the App root so its fixed drawer/backdrop keep
 *     their stacking context.
 *   - `app-header-brand` — the presentation logo, portalled by the screens that
 *     already decided to show one (Home.vue, Presentation.vue) with their
 *     existing `v-if`s untouched.
 *
 * `min-height` keeps the row — and therefore the hamburger's position — exactly
 * the same when the brand slot renders nothing, which is the "logo = none"
 * (white-label / `notShowAhaSlidesLogo`) case the reporter called out.
 */
export default {
  name: 'AppHeader',
}
</script>

<style lang="scss" scoped>
.app-header {
  display: flex;
  align-items: flex-start;
  // 12px gutter + the 40px toggle + 12px gutter. Flex-start (not center) so the
  // toggle sits at the same offset whether or not a logo renders next to it.
  min-height: 64px;

  &__side {
    flex: 0 0 64px;
    width: 64px;
  }

  &__brand {
    flex: 1 1 auto;
    min-width: 0;
  }
}
</style>
